import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { error } from '@helsenorge/framework-utils/logger';
import FeedbackButton from '../feedbackbutton';
import FeedbackModal from '../feedbackmodal';
import FeedbackPanel from '../feedbackpanel';
import styles from './styles.module.scss';
/**
 * Viser invitasjon til å delta i undersøkelse fra UX Signals
 */
const UxSignalsInvitation = (props) => {
    const [study, setStudy] = useState(null);
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(`https://api.uxsignals.com/v2/study/id/${props.id}/active`);
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const result = (await response.json());
                setStudy(result);
            }
            catch (e) {
                error(`Kunne ikke hente data om UX Signals-undersøkelse med ID "${props.id}"`, e);
            }
        };
        fetchData();
    }, [props.id]);
    if (!study?.active) {
        return null;
    }
    const buttons = (_jsx(_Fragment, { children: study.firstQuestion.options.map((option, index) => (_jsx(FeedbackButton, { variant: index === 0 ? 'outline' : 'borderless', onClick: props.onClose, href: option.answerUrl, htmlMarkup: "a", children: option.label }, option.position))) }));
    const contents = (_jsxs(_Fragment, { children: [study.firstQuestion.description, props.disclaimerText && _jsx("p", { className: styles.disclaimertext, children: props.disclaimerText })] }));
    switch (props.component) {
        case 'panel-static':
            return (_jsx(FeedbackPanel, { buttons: buttons, closeButtonText: props.closeButtonText, onClose: props.onClose, title: study.firstQuestion.header, variant: 'static', children: contents }));
        case 'panel-expander':
            return (_jsx(FeedbackPanel, { buttons: buttons, title: study.firstQuestion.header, variant: 'expander', children: contents }));
        case 'modal':
            return (_jsx(FeedbackModal, { buttons: buttons, title: study.firstQuestion.header, closeButtonText: props.closeButtonText, onClose: props.onClose, children: contents }));
    }
};
export default UxSignalsInvitation;
